module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 512 512\"><path d=\"M146.75 51Q102 70 70.25 102q-32.75 32.75-51.5 77.375T0 272t18.75 92.625 51.5 77.125q32.5 32.75 77.125 51.5T240 512t92.625-18.75T410 441.75q32.5-32.5 51.25-77.125T480 272t-18.75-92.625T410 102q-32.75-32.5-77.375-51.25T240 32q-49 0-93.25 19zm230 308.5l-49.25 49.25-87.5-87.5-87.5 87.5-49.25-49.25 87.5-87.5-87.5-87.5 49.25-49.25L240 222.5l87.5-87.25 49.25 49.25L289.5 272z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/ClearIcon/ClearIcon.svg
 ** module id = 639
 ** module chunks = 0
 **/